import { render, staticRenderFns } from "./SystemSettingIndex.vue?vue&type=template&id=b6af80f8&scoped=true&"
import script from "./SystemSettingIndex.vue?vue&type=script&lang=js&"
export * from "./SystemSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./SystemSettingIndex.vue?vue&type=style&index=0&id=b6af80f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6af80f8",
  null
  
)

export default component.exports